import { useEffect } from 'react';
import { LiStyled, UlStyled } from './styled';
import { getQueryVariable, sendToGA } from '@/components/util';
import { MenuType } from '@/_models/Menu';

interface MenuNavProps {
  rtl: any;
  menus: any;
  openMenu: (i: number, j: number | null) => void;
  loadModel: (...args: any) => void;
  menuRef: any;
  menuSettings?: any;
  resetMenus?: any;
  currentSweep?: any;
  deprecatedSweeps?: any;
}

export default function MenuNav(props: MenuNavProps) {
  const { menus, openMenu, loadModel, rtl, menuRef, menuSettings, resetMenus, currentSweep, deprecatedSweeps } = props;

  const disableActive = () => {
    const newMenus = menus?.map((menu) => ({ ...menu, isActive: false, subMenus: menu?.subMenus.map((subMenu) => ({ ...subMenu, isActive: false })) }));
    resetMenus(newMenus);
  };

  useEffect(() => {
    const updatedMenus = menus?.map((menu) => {
      const ss = +getQueryVariable(menu.url, 'ss');
      const scanId = ss > 0 && deprecatedSweeps?.length > 0 ? deprecatedSweeps[ss - 1].sweep_uuid.replace(/-/g, '') : null;

      const updatedSubMenus = menu.subMenus?.map((subMenu) => {
        const subMenuId = subMenu.type === MenuType.Treedis ? getQueryVariable(subMenu.url, 's') : null;
        if ((subMenuId === currentSweep?.id || scanId === currentSweep?.id) && subMenu.shouldHighlight) {
          return { ...subMenu, visited: true };
        }
        const updatedSubSubMenus = subMenu.subSubMenus?.map((subSubMenu) => {
          const subSubMenuId = subSubMenu.type === MenuType.Treedis ? getQueryVariable(subSubMenu.url, 's') : null;
          if ((subSubMenuId === currentSweep?.id || scanId === currentSweep?.id) && subSubMenu.shouldHighlight) {
            return { ...subSubMenu, visited: true };
          }
          return subSubMenu;
        });
        return { ...subMenu, subSubMenus: updatedSubSubMenus };
      });
      const menuId = menu.type === MenuType.Treedis ? getQueryVariable(menu.url, 's') : null;
      if ((menuId === currentSweep?.id || scanId === currentSweep?.id) && menu.shouldHighlight) {
        return { ...menu, visited: true };
      }
      return { ...menu, subMenus: updatedSubMenus };
    });
    resetMenus(updatedMenus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSweep?.id]);

  return (
    <UlStyled id="menu" className={rtl ? 'rtl' : ''} ref={menuRef} scrollbarColor={menuSettings?.scrollbarColor}>
      {menus &&
        menus.map((menu: any, i: number) =>
          menu.subMenus && menu.subMenus.length > 0 ? (
            <div key={i} className="sublinks-container">
              <LiStyled
                className={`mainLink ${menus[i].open ? 'open' : ''}`}
                onClick={() => openMenu(i, null)}
                bgColor={menuSettings?.menuActiveColor}
                textColor={menuSettings?.menuTxtColor}
                isActive={menu.visited}
                {...(menus[i].open && { openedColor: menuSettings?.openedMenuColor })}
              >
                {menu.title}
                <i className="fas fa-caret-down" />
              </LiStyled>
              <ul className={`sublinks ${menus[i].open ? 'open' : 'closed'}`}>
                {menu.subMenus.map((subMenu: any, j: number) =>
                  subMenu.subSubMenus && subMenu.subSubMenus.length > 0 ? (
                    <div key={j} className="sub_sublinks-container">
                      <LiStyled
                        className={`mainLink ${menus[i].subMenus[j].open ? 'open' : ''}`}
                        onClick={() => openMenu(i, j)}
                        bgColor={menuSettings?.menuActiveColor}
                        textColor={menuSettings?.menuTxtColor}
                        isActive={subMenu.visited}
                        {...(menus[i].subMenus[j].open && { openedColor: menuSettings?.openedMenuColor })}
                      >
                        {subMenu.title}
                        <i className="fas fa-caret-down" />
                      </LiStyled>
                      <ul className={`sub_sublinks ${menus[i].subMenus[j].open ? 'open' : 'closed'}`}>
                        {subMenu.subSubMenus.map((subSubMenu: any, x: number) => (
                          <LiStyled
                            key={x}
                            onClick={() => {
                              console.log(1);
                              loadModel(subSubMenu);
                              sendToGA('event', {
                                eventCategory: 'Place',
                                eventAction: 'click',
                                eventLabel: subSubMenu.title,
                                eventType: subSubMenu.type,
                              });
                            }}
                            className="loadModel"
                            bgColor={menuSettings?.menuActiveColor}
                            textColor={menuSettings?.menuTxtColor}
                            isActive={subSubMenu.visited || subSubMenu.isActive}
                          >
                            {subSubMenu.title}
                          </LiStyled>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    <LiStyled
                      key={j}
                      onClick={() => {
                        console.log(2);
                        loadModel(subMenu);
                        sendToGA('event', {
                          eventCategory: 'Place',
                          eventAction: 'click',
                          eventLabel: subMenu.title,
                          eventType: subMenu.type,
                        });
                      }}
                      className="loadModel"
                      bgColor={menuSettings?.menuActiveColor}
                      textColor={menuSettings?.menuTxtColor}
                      isActive={subMenu.visited || subMenu.isActive}
                      {...(subMenu.isActive && { onMouseEnter: disableActive })}
                    >
                      {subMenu.title}
                    </LiStyled>
                  ),
                )}
              </ul>
            </div>
          ) : (
            <LiStyled
              key={i}
              onClick={() => {
                loadModel(menu);
                sendToGA('event', {
                  eventCategory: 'Place',
                  eventAction: 'click',
                  eventLabel: menu.title,
                  eventType: menu.type,
                });
              }}
              {...(menu.isActive && { onMouseEnter: disableActive })}
              className="loadModel"
              isActive={menu.visited || menu.isActive}
              bgColor={menuSettings?.menuActiveColor}
              textColor={menuSettings?.menuTxtColor}
            >
              {menu.title}
            </LiStyled>
          ),
        )}
    </UlStyled>
  );
}
